import { createContext } from "react";

export enum IOptionType {
  hoverMenu = "list.enable.hovermenu",
  hoverMenuPreview = "preview.enable.hovermenu",
  showLead = "list.show.lead",
  showImages = "email.show.images",
  caseAttachAttachmentsLocation = "case.attach.attachments.modal.location",
  caseAttachParticipantsLocation = "case.attach.participants.modal.location",
  caseInNewTabView = "case.new.tab.view",
}

export interface IOptions {
  Type: IOptionType;
  Value: string;
}

type ISettingsContext = {
  options: IOptions[];
  setOptions: (options: IOptions[]) => void;
};

const settingsContext = createContext<ISettingsContext>({
  options: [],
  setOptions: () => {},
});

export default settingsContext;
